module.exports = "../fonts/revicons.woff";